import { createClient } from '@supabase/supabase-js';

const url = (process.env.REACT_APP_SUPABASE_URL || '').trim();
const anonKey = (process.env.REACT_APP_SUPABASE_ANON_KEY || '').trim();

/**
 * Browser-only Supabase client for the React dashboard (Google OAuth).
 * Uses a dedicated storage key so it does not share state with other apps.
 */
export const supabaseBrowser =
  url && anonKey
    ? createClient(url, anonKey, {
        auth: {
          persistSession: true,
          storageKey: 'clientflow_dashboard_supabase',
          detectSessionInUrl: true,
          flowType: 'pkce',
        },
      })
    : null;
